// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements

export const environmentProd = {
  production: true,
  appVersion: "1.11.2",
  USERDATA_KEY: "authf649fc9a5f755",
  isMockEnabled: true,
  apiUrl: "https://prod.api.planejebem.app/rest",
  apiFamilyUrl: "https://prod.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://prod.assets.planejebem.app",
  GOOGLE_KEY:
    "838381896557-2606ckk0dqc6al56s6a9h5a2qr94ig86.apps.googleusercontent.com",
  GOOGLE_TAG: "GTM-NBL4DJVX",
  FACEBOOK_KEY: "482124826091204",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  COOKIE_CONSENT: "mawdy",
  ENABLE_CHATVOLT: false,
};

export const environmentTokio = {
  production: true,
  appVersion: "1.11.2",
  USERDATA_KEY: "authf649fc9a5f533",
  isMockEnabled: true,
  apiUrl: "https://prod.api.planejebem.app/rest",
  apiFamilyUrl: "https://prod.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://prod.assets.planejebem.app",
  GOOGLE_KEY:
    "838381896557-2606ckk0dqc6al56s6a9h5a2qr94ig86.apps.googleusercontent.com",
  GOOGLE_TAG: "GTM-NBL4DJVX",
  FACEBOOK_KEY: "482124826091204",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  COOKIE_CONSENT: "mawdy",
  ENABLE_CHATVOLT: false,
};

export const environmentDev = {
  production: false,
  appVersion: "0.2",
  USERDATA_KEY: "authf649fc9a5f533",
  isMockEnabled: true,
  apiUrl: "https://dev.api.planejebem.app/rest",
  apiFamilyUrl: "https://dev.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://dev.assets.planejebem.app/",
  GOOGLE_KEY:
    "838381896557-2606ckk0dqc6al56s6a9h5a2qr94ig86.apps.googleusercontent.com",
  GOOGLE_TAG: "G-6WVJGDJQ31",
  FACEBOOK_KEY: "482124826091204",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  ENABLE_CHATVOLT: true,
};

export const environmentLocal = {
  production: false,
  appVersion: "0.2",
  USERDATA_KEY: "authf649fc9a5f533",
  isMockEnabled: true,
  apiUrl: "http://localhost:8991/rest",
  apiFamilyUrl: "http://localhost:8991/rest/family",
  apiAssetsUrl: "http://localhost:9032",
  GOOGLE_KEY:
    "838381896557-2606ckk0dqc6al56s6a9h5a2qr94ig86.apps.googleusercontent.com",
  GOOGLE_TAG: "G-6WVJGDJQ31",
  FACEBOOK_KEY: "482124826091204",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  Public_path: "../../../../../../public",
  ENABLE_CHATVOLT: true,
};

export const environmentStaging = {
  production: true,
  appVersion: "0.2",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: true,
  apiUrl: "https://staging.api.planejebem.app/rest",
  apiFamilyUrl: "https://staging.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://staging.assets.planejebem.app",
  GOOGLE_KEY:
    "838381896557-16ei1jcfjqauuagrotl57af0ditrpq49.apps.googleusercontent.com",
  GOOGLE_TAG: "GTM-553NZF6V",
  FACEBOOK_KEY: "206795227654091",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  COMPANY: "",
  ENABLE_CHATVOLT: false,
};
export const environmentSandbox = {
  production: true,
  appVersion: "0.2",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: true,
  apiUrl: "https://prod.api.planejebem.app/rest",
  apiFamilyUrl: "https://prod.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://prod.assets.planejebem.app",
  GOOGLE_KEY:
    "838381896557-16ei1jcfjqauuagrotl57af0ditrpq49.apps.googleusercontent.com",
  GOOGLE_TAG: "GTM-553NZF6V",
  FACEBOOK_KEY: "206795227654091",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  COMPANY: "",
  ENABLE_CHATVOLT: false,
};
export const environmentApoioPerda = {
  production: true,
  appVersion: "0.2",
  USERDATA_KEY: "authf649fc9a5f55",
  isMockEnabled: true,
  apiUrl: "https://apoioperda.api.planejebem.app/rest",
  apiFamilyUrl: "https://apoioperda.api.planejebem.app/rest/family",
  apiAssetsUrl: "https://apoioperda.assets.planejebem.app",
  GOOGLE_KEY:
    "838381896557-16ei1jcfjqauuagrotl57af0ditrpq49.apps.googleusercontent.com",
  GOOGLE_TAG: "GTM-553NZF6V",
  FACEBOOK_KEY: "206795227654091",
  RDS_BASE_URL: "https://api.rd.services/",
  RDS_KEY: "bNVAQLhcObXXLCtoVvIXGDngDETdDOBaVvty",
  RDS_TOKEN: "b8f7327594bf1028d0eb2e0b898f23c3",
  VALUE_PAYMENT: 348,
  COMPANY: "",
  ENABLE_CHATVOLT: false,
};

const discriminatorEnv = (env: string) => {
  switch (env) {
    case "DEV":
      return environmentDev;
    case "LOCAL":
      return environmentLocal;
    case "PROD":
      return environmentProd;
    case "TOKIO":
      return environmentTokio;
    case "STAGING":
      return environmentStaging;
    case "SANDBOX":
      return environmentSandbox;
    case "APOIO_PERDA":
      return environmentApoioPerda;
    default:
      return environmentDev;
  }
};
export const envName = 'APOIO_PERDA'; // Set the environment name here
export const environment = discriminatorEnv(envName);

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
